import React, { useEffect } from 'react';

import Scrolltop from '../components/Scrolltop';

import "./refundpolicy.css";
import { Footer } from '../components/footer';

import { Upperbox } from '../components/Upperbox';

import Nav from "../components/Nav";

const Refundpolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='page-background'>
      <Upperbox />
      <Nav />
     

      {/* Refund Policy Section */}
      <div className='refund-aboutus-container'>
        <div className='refund-aboutus-content'>
          <div className='refund-aboutus-text'>
            <h1 className='refund-ab-u' data-aos="fade-down">Refund Policy</h1>
            <p>
              At Sri Krishnaa Authentic Indian Cuisine, customer satisfaction is our top priority. We aim to ensure that every customer enjoys their experience with us. However, we understand that issues may arise. This refund policy outlines the circumstances under which refunds may or may not be issued.
            </p>

            <h2 className='refund-title'>Orders and Refunds</h2>
            <p>
              - Refunds are only considered if there has been an error in the preparation or delivery of your order. Examples include receiving the wrong dish or if the food quality does not meet the standards promised.
            </p>
            <p>
              - If you have an issue with your order, we kindly request that you contact us immediately, providing details and supporting evidence (e.g., photographs). This will help us address the problem efficiently.
            </p>

            <h2 className='refund-title'>Eligibility for Refunds</h2>
            <p>
              - Refunds are not applicable once the food has been consumed, unless there is a valid health-related concern, in which case we will investigate thoroughly.
            </p>
            <p>
              - Any refund requests must be made within 24 hours of receiving your order. Refunds requested after this timeframe will be reviewed on a case-by-case basis.
            </p>
            <p>
              - Refunds are not provided for food that has been ordered but not picked up or delivered due to the customer being unavailable.
            </p>

            <h2 className='refund-title'>Partial Refunds</h2>
            <p>
              - In cases where only part of the order is incorrect or unsatisfactory, a partial refund or replacement for the specific item(s) will be considered.
            </p>
            <p>
              - Delivery fees are non-refundable unless the error in the order is directly related to the delivery service.
            </p>

            <h2 className='refund-title'>Method of Refund</h2>
            <p>
              - Approved refunds will be processed to the original payment method used during the order. Please allow up to 7 business days for the refund to reflect in your account, depending on your bank or payment provider.
            </p>
            <p>
              - For cash payments, refunds will be issued as store credit, which can be redeemed on your next visit.
            </p>

            <h2 className='refund-title'>Cancellations</h2>
            <p>
              - Orders can be cancelled free of charge if the cancellation request is received before food preparation begins. Once the preparation has started, refunds will not be issued for cancellations.
            </p>
            <p>
              - If you need to make a change to your order, please contact us immediately. Modifications are subject to availability and may incur additional charges.
            </p>

            <h2 className='refund-title'>Special Offers and Discounts</h2>
            <p>
              - Refunds are not available for orders placed using promotional codes, discounts, or special offers unless the issue is directly related to the quality of the food or service provided.
            </p>

            <h2 className='refund-title'>Contact Us</h2>
            <p>
              If you have any questions or concerns about your order or this refund policy, please do not hesitate to get in touch with us. Our team is here to assist and ensure your satisfaction.
            </p>
            <ul>
            <li>Email: <a href="mailto:info@srikrishnaaindiancuisine.co.uk">info@srikrishnaaindiancuisine.co.uk</a></li>
              <li>Phone: +44 7554466904</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Additional Components */}
   
      <Scrolltop />
     
      <Footer />
    </div>
  );
};

export default Refundpolicy;
